module.exports = __webpack_public_path__ + "img/kg2.6a63514b.png";